"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineTimeoutException = void 0;
class OfflineTimeoutException extends Error {
    constructor(e) {
        super(e);
        this.stack = e.stack;
        this.name = "OfflineTimeoutException";
        this.code = "OFFLINE_TIMEOUT";
    }
}
exports.OfflineTimeoutException = OfflineTimeoutException;
